/**
 * The New Toast Container component
 */
import { ToastContainer as ToastifyContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// this css import is needed to toastify styling
import './index.css';

import CloseButton from '../ReusableComponents/NewDesign/Buttons/CloseButton';
import successIcon from '../../Assets/icons/toastIcon/successIcon.svg';
import warningIcon from '../../Assets/icons/toastIcon/warningIcon.svg';
import errorIcon from '../../Assets/icons/toastIcon/errorIcon.svg';
import infoIcon from '../../Assets/icons/toastIcon/infoIcon.svg';

const iconTypes = {
  success: successIcon,
  warning: warningIcon,
  error: errorIcon,
  info: infoIcon,
};

function CloseToast({ closeToast }) {
  return (
    <div style={{ marginRight: '16px' }}>
      <CloseButton onClick={closeToast} />
    </div>
  );
}

function getIcon(type, size = 20) {
  return <img src={iconTypes[type]} alt={type} width={size} height={size} />;
}

export default function ToastContainer(props) {
  return (
    <ToastifyContainer
      position="top-right"
      hideProgressBar
      closeButton={CloseToast}
      icon={({ type }) => getIcon(type)}
    />
  );
}
